import AsyncAutocompleteField from './AsyncAutocompleteField';

export default AsyncAutocompleteField;
